export const equipmentConstants = {
    EQUIPMENT_GET_REQUEST: 'EQUIPMENT_GET_REQUEST',
    EQUIPMENT_GET_SUCCESS: 'EQUIPMENT_GET_SUCCESS',
    EQUIPMENT_GET_FAILURE: 'EQUIPMENT_GET_FAILURE'
};